const types = [
  {
    name: 'simple',
    label: 'Simple',
  },
  {
    name: 'pipeline_experiment',
    label: 'Pipeline experiment',
  },
  {
    name: 'destination',
    label: 'Destination',
  },
];

export default types;
